'use client';

import dynamic from 'next/dynamic';

const AIPlannerSheet = dynamic(
  () =>
    import('./ai-planner-sheet').then((m) => ({ default: m.AIPlannerSheet })),
  { ssr: false }
);

const AIPlannerBanner = dynamic(
  () =>
    import('./ai-planner-banner').then((m) => ({
      default: m.AIPlannerBanner,
    })),
  { ssr: false }
);

export default function AIPlannerLazyFeatures() {
  return (
    <>
      <AIPlannerSheet />
      <AIPlannerBanner />
    </>
  );
}
